import { axiosInstance, KASHU_GLOBAL_ON_ID } from "@/axios/interceptors";
import { ZodSentryReporter } from "@/lib/zod-sentry-reporter";
import { z } from "zod";

export const PaymentSessionSchema = z.object({
	iframe_access_token: z.string(),
});

export type PaymentSession = z.infer<typeof PaymentSessionSchema>;

export const getSoftpointCredentials = async (locationId: number) => {
	const response = await axiosInstance.get(
		`/locations/${locationId}/processor/secure_web_session?global_on_id=${KASHU_GLOBAL_ON_ID}&processor_code=SOFTPOINT`,
	);

	return ZodSentryReporter.parse(PaymentSessionSchema, response);
};
